import basicdata from '@manage/api/api.basicdata'
export default [
  {
    type: 'input',
    placeholder: '设备SN码',
    filed: 'assetNumber',
    default: ''
  },
  {
    type: 'select',
    placeholder: '设备型号',
    filed: 'assetId',
    default: '',
    query: basicdata.device_model_select + '?devType=02'
  },
  {
    type: 'select',
    placeholder: '大客户',
    filed: 'customerId',
    default: '',
    query: basicdata.customer_select + '?accountLevel=euna'
  },
  {
    type: 'select',
    placeholder: '在线状态',
    filed: 'online',
    default: '',
    options: [
      {
        code: 'offline',
        name: '离线'
      },
      {
        code: 'online',
        name: '在线'
      }
    ]
  }
]
